<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Nova Usina' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Usinas',
                href: '#/power-plants',
              },
              {
                text: 'Cadastro Usina',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Nome">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Responsável Principal">
                <b-form-input
                  v-model="state.main_owner"
                  required
                  placeholder="Informe o Responsável Principal"
                  :state="isOk('main_owner')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('main_owner')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="CPF/CNPJ do Gerador">
                <b-form-input
                  v-model="state.socialNumber"
                  required
                  placeholder="Informe o CPF/CNPJ do Gerador"
                  :state="isOk('socialNumber')"
                  v-mask="socialNumberMask"
                  @input="updateSocialNumberMask"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('socialNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Razão Social do Gerador">
                <b-form-input
                  v-model="state.power_plant_alias"
                  required
                  placeholder="Informe a Razão Social do Gerador"
                  :state="isOk('power_plant_alias')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('power_plant_alias')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Cooperativa">
                <v-select
                  :options="viewData.cooperatives"
                  v-model="state.cooperativeId"
                  label="denomination"
                  :reduce="coop => coop.id"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: isOk('cooperativeId') === false ? 'block' : 'none',
                  }"
                  >{{ getError('cooperativeId') }}</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group label="Número da instalação">
                <b-form-input
                  v-model="state.power_plant_installation_number"
                  required
                  placeholder="Informe o Número da Instalação"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('power_plant_installation_number')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="Status">
                <b-form-select
                  v-model="state.status"
                  :options="viewData.status"
                  :state="isOk('status')"
                  class="mb-3"
                >
                  <option disabled value>Selecione o status</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('status')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="Tipo">
                <b-form-select
                  v-model="state.type"
                  :options="viewData.types"
                  :state="isOk('type')"
                  class="mb-3"
                >
                  <option disabled value>Selecione o tipo</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('type')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Tarifa-base para remuneração"
              >
                <b-form-select
                  v-model="state.base_tariff"
                  :options="viewData.baseTariffTypes"
                  :state="isOk('base_tariff')"
                  class="mb-3"
                >
                  <option disabled value
                    >Selecione o tipo de tarifa-base</option
                  >
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('base_tariff')
                }}</b-form-invalid-feedback>
              </b-form-group>
              <!--
              <b-form-group label="Tarifa-base para remuneração">
                <b-form-input
                  placeholder="Informe a tarifa-base para remuneração"
                  v-model="state.baseTariff"
                  state="isOk('baseTariff')"
                  type="number"
                ></b-form-input>
              </b-form-group> -->

              <b-form-group label="Tarifa da Usina (R$/kWh)">
                <b-form-input
                  v-model="state.powerTariff"
                  required
                  placeholder="Informe a Tarifa da Usina (R$/kWh)"
                  :state="isOk('powerTariff')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('powerTariff')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Porcentagem da tarifa-base para remuneração">
                <b-form-input
                  placeholder="Informe a Porcentagem da tarifa-base para remuneração"
                  v-model="state.percentage"
                  state="isOk('percentage')"
                  type="number"
                  min="0"
                  max="100"
                ></b-form-input>

                <b-form-invalid-feedback>{{
                  getError('percentage')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Potência Instalada (kWac)">
                <b-form-input
                  v-model="state.powerInstalled"
                  required
                  placeholder="Informe o Potência Instalada (kWac)"
                  :state="isOk('powerInstalled')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('powerInstalled')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Energia Planejada (kWh)">
                <b-form-input
                  v-model="state.planned_energy"
                  required
                  placeholder="Informe a Energia Planejada (kWh)"
                  :state="isOk('planned_energy')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('planned_energy')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Energia Gerada (kWh)">
                <b-form-input
                  v-model="state.generated_energy"
                  required
                  placeholder="Informe a Energia Gerada (kWh)"
                  :state="isOk('generated_energy')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('generated_energy')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Energia Injetada (kWh)">
                <b-form-input
                  v-model="state.injected_energy"
                  required
                  placeholder="Informe a Energia Injetada (kWh)"
                  :state="isOk('injected_energy')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('injected_energy')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Energia Acumulada (kWh)">
                <b-form-input
                  v-model="state.accumulated_generate_vs_energy"
                  required
                  placeholder="Informe a Energia Injetada (kWh)"
                  :state="isOk('accumulated_generate_vs_energy')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('accumulated_generate_vs_energy')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Região">
                <select v-model="state.region" class="form-control">
                  <option disabled value>Selecione a região</option>
                  <option value="Norte">Norte</option>
                  <option value="Nordeste">Nordeste</option>
                  <option value="Sudeste">Sudeste</option>
                  <option value="CentroOeste">Centro Oeste</option>
                  <option value="Sul">Sul</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('region') }"></div>
                <b-form-invalid-feedback v-if="isOk('region') === false">{{
                  getError('region')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Estado"
                label-for="input-1"
              >
                <b-form-select
                  v-model="state.state"
                  :options="viewData.states"
                  :state="isOk('state')"
                >
                  <option disabled value>Selecione um estado</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('state')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Cidade">
                <b-form-input
                  v-model="state.city"
                  required
                  placeholder="Informe a Cidade"
                  :state="isOk('city')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('city')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="CEP" label-for="input-1">
                <b-form-input
                  v-model="state.postcode"
                  placeholder="Informe o CEP"
                  :state="isOk('postcode')"
                  v-mask="['#####-###']"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('postcode')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Endereço">
                <b-form-input
                  v-model="state.adress"
                  required
                  placeholder="Informe a Endereço"
                  :state="isOk('adress')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('adress')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Proprietário do Imóvel">
                <b-form-input
                  v-model="state.lessor_property"
                  required
                  placeholder="Proprietário do Imóvel"
                  :state="isOk('lessor_property')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('lessor_property')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Contrato de Locação">
                <b-form-input
                  v-model="state.lease_agreement"
                  required
                  placeholder="Informe o Contrato de Locação"
                  :state="isOk('lease_agreement')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('lease_agreement')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <!--               <b-form-group
                id="input-group-1"
                label="Data Início"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('start')"
                  id="example-datepicker-beg"
                  placeholder="Selecione uma data"
                  v-model="state.start"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('start')
                }}</b-form-invalid-feedback>

                <b-form-invalid-feedback>{{
                  getError('start')
                }}</b-form-invalid-feedback>
              </b-form-group> -->

              <b-form-group
                id="input-group-2"
                label="Data Início"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.start"
                  :type="'date'"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('start')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <!--               <b-form-group
                id="input-group-2"
                label="Data Fim"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('end')"
                  id="example-datepicker-end"
                  placeholder="Selecione uma data"
                  v-model="state.end"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('end')
                }}</b-form-invalid-feedback>

                <b-form-invalid-feedback>{{
                  getError('end')
                }}</b-form-invalid-feedback>
              </b-form-group> -->

              <b-form-group
                id="input-group-2"
                label="Data Fim"
                label-for="input-1"
              >
                <b-form-input v-model="state.end" :type="'date'"></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('end')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <!--               <b-form-group label="Distribuidora">
                <v-select
                  :options="viewData.distributors"
                  :reduce="(dist) => dist.id"
                  label="name"
                  v-model="state.distributorId"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: isOk('distributorId') === false ? 'block' : 'none',
                  }"
                  >{{ getError('distributorId') }}</b-form-invalid-feedback
                >
              </b-form-group> -->

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import StatesJson from '../../vue/estados.json';

const API = new Api();

export default {
  name: 'power-plant-edit',
  data: function() {
    return {
      state: {
        name: '',
        cooperativeId: '',
        distributorId: '',
        socialNumber: '',
        status: '',
        type: '',
        power_plant_alias: '',
        power_plant_installation_number: '',
        main_owner: '',
        base_tariff: '',
        powerTariff: 0,
        powerInstalled: 0,
        planned_energy: 0,
        generated_energy: 0,
        injected_energy: 0,
        accumulated_generate_vs_energy: 0,
        region: '',
        state: '',
        city: '',
        postcode: '',
        adress: '',
        lessor_property: '',
        lease_agreement: '',
        start: '',
        end: '',
        endNew: '',
        socialNumberMask: '',
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
        cooperatives: [],
        distributors: [],
      },
    };
  },
  beforeMount: async function() {
    await this.getLists();

    this.viewData.states = StatesJson.estados;

    this.viewData.status = [
      { value: 'ACTIVE', text: 'Ativo' },
      { value: 'INACTIVE', text: 'Inativo' },
    ];

    this.viewData.types = [
      { value: 'MICROGENERATION', text: 'Microgeração' },
      { value: 'MINIGENERATION', text: 'Minigeração' },
    ];

    this.viewData.baseTariffTypes = [
      { value: 'NOTAXES', text: 'SEM impostos' },
      { value: 'TAXES', text: 'COM impostos' },
    ];

    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/power-plant/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.updateSocialNumberMask();
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD;
    },
    async getLists() {
      try {
        this.viewData.loading = true;

        const resultCoop = await API.post('/execute', {
          path: '/cooperatives?no_limit=true',
          method: 'get',
        });

        const resultDist = await API.post('/execute', {
          path: '/distributors?no_limit=true',
          method: 'get',
        });

        this.viewData.cooperatives = resultCoop.model.list;
        this.viewData.distributors = resultDist.model.list;

        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    updateSocialNumberMask() {
      this.socialNumberMask =
        this.state.socialNumber
          .replace(/\./g, '')
          .replace(/\-/g, '')
          .replace(/\//g, '').length <= 11
          ? '###.###.###-##'
          : '##.###.###/####-##';
    },
    async save() {
      try {
        let data = _.cloneDeep(this.state);
        data.socialNumber = _.replace(data.socialNumber, '.', '');
        data.socialNumber = data.socialNumber
          .replace(/\./g, '')
          .replace(/\-/g, '')
          .replace(/\//g, '');

        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/power-plant/${this.viewData.id}`
            : '/power-plant/',
          method: this.viewData.id ? 'put' : 'post',
          data: data,
        });

        this.$toast.success('Usina incluída com sucesso');

        this.$router.push('/power-plants');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
